import ModuleContent from 'features/shared/layout/content/ModuleContent';
import Header from 'features/shared/layout/header/Header';
import React from 'react';
import { useParams } from 'react-router-dom';
import AccountDetailSection from 'features/accounts/sections/AccountDetailSection';
import RolesChecker from 'features/customer/components/RolesChecker';
import { useTranslation } from 'react-i18next';

interface Props {
  id: string;
}

const AccountDetail = () => {
  // translations
  const tLabels = useTranslation("shared\\moduleNames").t;

  const { id } = useParams<Props>();

  return (
    <RolesChecker enabledRoles="Admin">
      <Header
        title={tLabels("accountDetail.title")}
        includeBreadcrumbs
        links={[{ text: tLabels("accounts.title"), to: "/accounts" }]}
      />
      <ModuleContent>
        <AccountDetailSection accountId={id} />
      </ModuleContent>
    </RolesChecker>
  )
}

export default AccountDetail;
